import {FC} from 'react'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useQueryResponsePagination} from '../../core/QueryResponseProvider'

const ListPagination: FC = () => {
  const pagination = useQueryResponsePagination()
  const {updateState} = useQueryRequest()

  const currentPage = pagination.current_page ?? 1
  const total = pagination.total ?? 0
  const perPage = pagination.per_page ?? 10
  const lastPage = Math.ceil(total / perPage) || 1

  if (lastPage <= 1) return null

  const pages = Array.from({length: lastPage}, (_, i) => i + 1)

  return (
    <div className='row'>
      <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start' />
      <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
        <div id='kt_table_downloads_paginate'>
          <ul className='pagination'>
            <li className={`paginate_button page-item previous ${currentPage === 1 ? 'disabled' : ''}`}>
              <button
                className='page-link'
                onClick={() => updateState({page: currentPage - 1})}
                disabled={currentPage === 1}
              >
                <i className='previous' />
              </button>
            </li>
            {pages.map((page) => (
              <li
                key={page}
                className={`paginate_button page-item ${page === currentPage ? 'active' : ''}`}
              >
                <button className='page-link' onClick={() => updateState({page})}>
                  {page}
                </button>
              </li>
            ))}
            <li className={`paginate_button page-item next ${currentPage === lastPage ? 'disabled' : ''}`}>
              <button
                className='page-link'
                onClick={() => updateState({page: currentPage + 1})}
                disabled={currentPage === lastPage}
              >
                <i className='next' />
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export {ListPagination}
